<template>
  <b-form-group
    v-bind="$attrs"
    :label="fieldLabel"
    :state="getValidationState(validatable, validationContext)"
    :label-cols-sm="labelColsSm"
    :class="controlClass"
    :label-class="labelClass"
  >
    <vue-typeahead-bootstrap
      v-model="query"
      :data="options"
      :minMatchingChars="minMatchingChars"
      :serializer="textFn"
      @hit="selected"
      @input="input"
      :inputClass="getValidationClass(validatable, validationContext)"
      showOnFocus
      :maxMatches="maxMatches"
    />
    <b-overlay class="mx-1" :show="loading" no-wrap />
    <b-form-invalid-feedback
      v-if="validatable"
      :state="getValidationState(validatable, validationContext)"
    >
      {{ validationContext.errors[0] }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { baseValidatableMixin } from "@foys-tech/foys-utils";

export default {
  components: {
    VueTypeaheadBootstrap,
  },
  mixins: [baseValidatableMixin],
  data: () => ({
    debounceTimeout: null,
    query: null,
    options: [],
    loading: false,
    preventQuery: false,
    preventValue: false,
  }),
  props: {
    validationContext: null,
    optionsFn: {
      type: Function,
      required: true,
    },
    optionsResultFn: {
      type: Function,
      default: null,
    },
    textFn: {
      type: Function,
      default: (i) => (i ? i.name : i),
    },
    valueFn: {
      type: Function,
      default: (i) => (i ? i.id : i),
    },
    initialQuery: null,
    minMatchingChars: {
      default: 0,
    },
    maxMatches: {
      default: 10,
    },
  },
  methods: {
    processInput($event) {
      return $event ? this.valueFn($event) : null;
    },
    selected($event) {
      this.preventQuery = true;
      this.preventValue = true;

      this.emitValue($event);
    },
    input($event) {
      if (!$event) {
        this.emitValue(null);
      }
    },
    loadOptions() {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      let me = this;
      let promise = new Promise((resolve) => {
        me.debounceTimeout = setTimeout(async function () {
          try {
            me.loading = true;
            let result = await me.optionsFn(me.query || me.initialQuery);
            me.loading = false;
            if (me.optionsResultFn) {
              me.options = me.optionsResultFn(result.data);
            } else {
              me.options = result && result.data ? result.data : result || [];
            }
          } catch (ex) {
            me.options = [];
          } finally {
            me.$emit("options", me.options);
            resolve();
          }
        }, 500);
      });
      return promise;
    },
    async loadValue() {
      if (this.value && this.optionsFn) {
        await this.loadOptions();
        let option = this.options.find((e) => this.valueFn(e) == this.value);
        if (option) {
          this.preventQuery = true;
          this.query = this.textFn(option);
        }
      } else {
        this.query = '';
      }
    },
  },
  watch: {
    query(val) {
      if (!this.preventQuery && val && val.length >= this.minMatchingChars) {
        this.loadOptions();
      }

      if (!val || val.length < this.minMatchingChars) {
        this.options = [];
      }
      this.preventQuery = false;
    },
    async value() {
      if (!this.value) {
        this.query = '';
        return;
      }
      if (!this.preventValue) {
        await this.loadValue();
      }
      this.preventValue = false;
    },
  },
  async created() {
    await this.loadValue();
  },
};
</script>
